import React from 'react'

const Wood = (props) => (
  <div id={props.Id} className="story">
    <h3>Choice of glass</h3>
    <p>
      The <strong>{props.ProductName}</strong> can be manufactured to accommodate several types and styles of glazing, below is a sample of some of our more popular styles.
    </p>
    <ul className="samples">
      <li title="Autumn">
        <img src="/static/images/texture-glass-autumn.jpg" alt="" />
      </li>
      <li title="Cotswold">
        <img src="/static/images/texture-glass-cotswold.jpg" alt="" />
      </li>
      <li title="Stippolyte">
        <img src="/static/images/texture-glass-stippolyte.jpg" alt="" />
      </li>
    </ul>
</div>
)

export default Wood